import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=308acf68&scoped=true&"
import script from "./setup.ts?vue&type=script&lang=ts&"
export * from "./setup.ts?vue&type=script&lang=ts&"
import style0 from "./setup.scss?vue&type=style&index=0&id=308acf68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308acf68",
  null
  
)

export default component.exports